/**
 * Created by why on 2019/10/21.
 */
import {
  dictList,
  dictDataList,
  dictDataInsert,
  dictInsert,
  dictUpdate,
  dictDataUpdate,
  dictDelete,
  dictDataDelete,
  getByDictType
} from '@/api/dict-manage'

export default {
  state: {
    list: [],
    loading: false,
    dictLoading: false,
    loadingSave: false,
    loadingDataSave: false,
    loadingDataDelete: false,
    loadingUpdate: false,
    loadingDataUpdate: false,
    loadingDelete: false,
    data: {
      dictList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      status: null,
      title: null
    }
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setLoading (state, {type, status}) {
      switch (type) {
        case 'loading':
          state.loading = status
          break
        case 'dictLoading':
          state.dictLoading = status
          break
        case 'loadingSave':
          state.loadingSave = status
          break
        case 'loadingDataSave':
          state.loadingDataSave = status
          break
        case 'loadingDataDelete':
          state.loadingDataDelete = status
          break
        case 'loadingDelete':
          state.loadingDelete = status
          break
        case 'loadingDataUpdate':
          state.loadingDataUpdate = status
          break
      }
    },
    setData (state, data) {
      state.data = {...state.data, ...data}
    }
  },
  getters: {
    dictList: state => state.list,
    dictLoading: state => state.loading,
    dictLoadingSave: state => state.loadingSave,
    dictTotal: state => state.data.total,
    dictDataList: state => state.data.dictList,
    dictDataLoading: state => state.dictLoading,
    loadingDataSave: state => state.loadingDataSave
  },
  actions: {
    getDictList ({ state, commit }) {
      commit('setLoading', {type: 'loading', status: true})
      return new Promise((resolve, reject) => {
        dictList().then(res => {
          const list = res.data.result
          commit('setList', list)
          commit('setLoading', {type: 'loading', status: false})
          resolve()
        }).catch(err => {
          commit('setLoading', {type: 'loading', status: false})
          reject(err)
        })
      })
    },
    getByDictType ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getByDictType(data).then(res => {
          const list = res.data.result
          resolve(list)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getDictDetailList ({ state, commit }, data) {
      commit('setLoading', {type: 'dictLoading', status: true})
      return new Promise((resolve, reject) => {
        dictDataList(data).then(res => {
          const data = res.data.result
          const dictList = data.records
          const pageSize = data.size
          const pageNum = data.current
          const total = data.total
          commit('setData', {dictList, pageSize, pageNum, total})
          commit('setLoading', {type: 'dictLoading', status: false})
          resolve()
        }).catch(err => {
          commit('setLoading', {type: 'dictLoading', status: false})
          reject(err)
        })
      })
    },
    dictInsert ({ state, commit }, data) {
      commit('setLoading', {type: 'loadingSave', status: true})
      return new Promise((resolve, reject) => {
        dictInsert(data).then(res => {
          commit('setLoading', {type: 'loadingSave', status: false})
          resolve(res)
        }).catch(err => {
          commit('setLoading', {type: 'loadingSave', status: false})
          reject(err)
        })
      })
    },
    dictDetailInsert ({ state, commit }, data) {
      commit('setLoading', {type: 'loadingDataSave', status: true})
      return new Promise((resolve, reject) => {
        dictDataInsert(data).then(res => {
          commit('setLoading', {type: 'loadingDataSave', status: false})
          resolve(res)
        }).catch(err => {
          commit('setLoading', {type: 'loadingDataSave', status: false})
          reject(err)
        })
      })
    },
    dictUpdate ({ state, commit }, data) {
      commit('setLoading', {type: 'loadingSave', status: true})
      return new Promise((resolve, reject) => {
        dictUpdate(data).then(res => {
          commit('setLoading', {type: 'loadingSave', status: false})
          resolve(res)
        }).catch(err => {
          commit('setLoading', {type: 'loadingSave', status: false})
          reject(err)
        })
      })
    },
    dictDetailUpdate ({ state, commit }, data) {
      commit('setLoading', {type: 'loadingDataSave', status: true})
      return new Promise((resolve, reject) => {
        dictDataUpdate(data).then(res => {
          commit('setLoading', {type: 'loadingDataSave', status: false})
          resolve(res)
        }).catch(err => {
          commit('setLoading', {type: 'loadingDataSave', status: false})
          reject(err)
        })
      })
    },
    delByIds ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        dictDelete(id).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    dictDataDelete ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        dictDataDelete(id).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/dict-manage.js